import 'babel-polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube)
// Importar y registrar componentes
import FlechasApp from '@/components/Flechas-componente'
Vue.component("Flechas-app", FlechasApp);
import audioPlayer from '@/components/audio-player'
Vue.component("audio-player", audioPlayer);
import botonCerrarModal from '@/components/boton-cerrar-modal'
Vue.component("boton-cerrar-modal-app", botonCerrarModal);
import header from '@/components/header'
Vue.component("header-app", header);
import dialogos from '@/components/dialogos'
Vue.component("dialogos-app", dialogos)
import dialogosTop from '@/components/dialogos-top'
Vue.component("dialogos-top-app", dialogosTop)
import navButtons from '@/components/nav-buttons'
Vue.component("nav-buttons-app", navButtons)
import navMenu from '@/components/nav-menu'
Vue.component("nav-menu-app", navMenu)
import svgContainer from '@/components/svg-container'
Vue.component("svg-container-app", svgContainer)
import modalApp from '@/components/modal'
Vue.component("modal-app", modalApp)
import youtubeVideoApp from '@/components/youtube-video'
Vue.component("youtube-video-app", youtubeVideoApp)
import modalResultadoApp from '@/components/modal-resultado'
Vue.component("modal-resultado-app", modalResultadoApp)
import modalVideoApp from '@/components/modal-video'
Vue.component("modal-video-app", modalVideoApp)

Vue.config.productionTip = false

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
    el.scrollIntoView({
      behavior: "smooth"
    })
  },
  componentUpdated: function (el) {
    // Focus the element
    el.focus()
    el.scrollIntoView({
      behavior: "smooth"
    })
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')